import * as PIXI from "pixi.js";
import { TweenMax, Power2 } from "gsap";
import HoverEffect from "./cursor-sticky-effect.js";
import CursorProperties from "./cursor-properties.js";

class CursorFunctions {
    constructor() {
        this.renderLoop = this.renderLoop.bind(this);
        this.cursorRadius = CursorProperties.radius;
    }
    createRenderContext() {
        const app = new PIXI.Application({
            transparent: true,
            //resolution: devicePixelRatio,
            autoStart: true,
            resizeTo: window,
            antialias: true,
        });
        app.renderer.autoResize = true;
        return app;
    }

    createCursorGraphics(radius, color, thickness) {
        const cursor = new PIXI.Graphics();
        cursor.lineStyle(thickness, color, 1);
        cursor.drawCircle(0, 0, radius);
        return cursor;
    }

    renderLoop(renderContext, stage, cursor) {
        requestAnimationFrame(
            this.renderLoop.bind(this, renderContext, stage, cursor)
        );
        if (cursor != undefined && cursor != null) {
            TweenMax.to(cursor.position, CursorProperties.followSpeed, {
                x: renderContext.renderer.plugins.interaction.mouse.global.x,
                y: renderContext.renderer.plugins.interaction.mouse.global.y,
                ease: Power2.easeout,
            });
        }

        renderContext.renderer.render(stage);
    }

    createStage(cursor) {
        const stage = new PIXI.Container();
        stage.addChild(cursor);
        return stage;
    }

    bindEffects(cursor) {
        TweenMax.to(this, 0.25, {
            ease: Power2.easeOut,
            cursorRadius: CursorProperties.radius,
            onUpdate: () => {
                cursor.clear();
                cursor.lineStyle(2, CursorProperties.color, 1);
                cursor.drawCircle(0, 0, this.cursorRadius);
            },
        });

        Array.from(document.querySelectorAll("[data-cursor-sticky]")).forEach(
            (item) => {
                let self = this;
                new HoverEffect(item);
                item.addEventListener("mouseenter", () => {
                    let bounds = item.getBoundingClientRect();
                    let max =
                        Math.max(bounds.width * 0.5, bounds.height * 0.5) *
                            1.15 +
                        CursorProperties.scaledPadding;
                    TweenMax.to(self, 0.25, {
                        ease: Power2.easeOut,
                        cursorRadius: max,
                        onUpdate: () => {
                            cursor.clear();
                            cursor.lineStyle(2, CursorProperties.color, 1);
                            cursor.drawCircle(0, 0, self.cursorRadius);
                        },
                    });
                });

                item.addEventListener("mouseleave", () => {
                    TweenMax.to(self, 0.25, {
                        ease: Power2.easeOut,
                        cursorRadius: CursorProperties.radius,
                        onUpdate: () => {
                            cursor.clear();
                            cursor.lineStyle(2, CursorProperties.color, 1);
                            cursor.drawCircle(0, 0, self.cursorRadius);
                        },
                    });
                });
            }
        );

        Array.from(document.querySelectorAll("[data-cursor-shrink]")).forEach(
            (item) => {
                let self = this;
                item.addEventListener("mouseenter", () => {
                    TweenMax.to(self, 0.25, {
                        ease: Power2.easeOut,
                        cursorRadius: CursorProperties.radius * 0.25,
                        onUpdate: () => {
                            cursor.clear();
                            cursor.lineStyle(2, CursorProperties.color, 1);
                            cursor.drawCircle(0, 0, self.cursorRadius);
                        },
                    });
                });

                item.addEventListener("mouseleave", () => {
                    TweenMax.to(self, 0.25, {
                        ease: Power2.easeOut,
                        cursorRadius: CursorProperties.radius,
                        onUpdate: () => {
                            cursor.clear();
                            cursor.lineStyle(2, CursorProperties.color, 1);
                            cursor.drawCircle(0, 0, self.cursorRadius);
                        },
                    });
                });
            }
        );

        Array.from(document.querySelectorAll(".fp-right a")).forEach((item) => {
            new HoverEffect(item);
        });
    }
}

export default new CursorFunctions();
